import type { FormInstance } from "antd/es/form";
import type { NamePath } from "antd/es/form/interface";

export type FocusFirstInvalidFieldOptions = {
  beforeFocus?: (name: NamePath) => void | Promise<void>;
  delayMs?: number;
};

const ERROR_INPUT_SELECTOR = [
  '.ant-form-item-has-error input:not([type="hidden"])',
  ".ant-form-item-has-error textarea",
  ".ant-form-item-has-error .ant-input",
  ".ant-form-item-has-error .ant-select-selection-search-input",
  ".ant-form-item-has-error .ant-input-number-input",
].join(", ");

export function focusFirstInvalidField(
  form: FormInstance,
  fieldName: NamePath,
  options?: FocusFirstInvalidFieldOptions,
): void {
  const delayMs = options?.delayMs ?? 250;

  const run = async () => {
    await options?.beforeFocus?.(fieldName);
    await new Promise((resolve) => setTimeout(resolve, delayMs));

    form.scrollToField(fieldName, { behavior: "smooth", block: "center" });

    const inst: any = form.getFieldInstance?.(fieldName);
    if (typeof inst?.focus === "function") {
      inst.focus();
      return;
    }

    const el = document.querySelector(ERROR_INPUT_SELECTOR) as HTMLElement | null;
    el?.focus?.();
  };

  void run();
}

export function getFirstInvalidFieldName(error: unknown): NamePath | undefined {
  const errorFields = (error as { errorFields?: Array<{ name?: NamePath }> })?.errorFields ?? [];
  return errorFields[0]?.name;
}